

export const DLModels = [

  { Modelo: "91", Ver: "1.4.7", description: "Data  Log   BT  España        DL  EU0  91", name: "DL EU0" },
  { Modelo: "92", Ver: "0.0.0", description: "Data  Log   BT  EU+ RUS       DL  EU1  92", name: "DL EU1" },
  { Modelo: "93", Ver: "0.0.0", description: "Data  Log   BT  EU+Islandia   DL  EU2  93", name: "DL EU2" },
  { Modelo: "94", Ver: "0.0.0", description: "Data  Log   BT  Afri/Asia     DL  AOM  94", name: "DL AOM" },
  { Modelo: "95", Ver: "0.0.0", description: "Data  Log   BT  Israel        DL  ISR  95", name: "DL ISR" },
  { Modelo: "96", Ver: "0.0.0", description: "Data  Log   BT  Paci/Amer     DL  OCL  96", name: "DL OCL" },
  { Modelo: "97", Ver: "0.0.0", description: "Data  Log   BT  EUE este      DL  EUE  97", name: "DL EUE" },
  { Modelo: "98", Ver: "1.4.7", description: "Data  Log   BT  Italia        DL  EU3  98", name: "DL EU3" },
  { Modelo: "99", Ver: "0.0.0", description: "Data  Log   BT                DL  ETI  99", name: "DL ETI" },

  { Modelo: "D1", Ver: "1.4.7", description: "Data  Log2  BT  España        DL2 EU0  D1", name: "DL2 EU0" },
  { Modelo: "D2", Ver: "0.0.0", description: "Data  Log2  BT  EU+ Rusia     DL2 EU1  D2", name: "DL2 EU1" },
  { Modelo: "D3", Ver: "0.0.0", description: "Data  Log2  BT  EU+ Islandia  DL2 EU2  D3", name: "DL2 EU2" },
  { Modelo: "D4", Ver: "0.0.0", description: "Data  Log2  BT  Afri/Asia     DL2 AOM  D4", name: "DL2 AOM" },
  { Modelo: "D5", Ver: "0.0.0", description: "Data  Log2  BT  Israel        DL2 ISR  D5", name: "DL2 ISR" },
  { Modelo: "D6", Ver: "0.0.0", description: "Data  Log2  BT  Paci/Amer     DL2 OCL  D6", name: "DL2 OCL" },
  { Modelo: "D7", Ver: "0.0.0", description: "Data  Log2  BT  EUE este      DL2 EUE  D7", name: "DL2 EUE" },
  { Modelo: "D8", Ver: "1.4.8", description: "Data  Log2  BT  EU            DL2 EU3  D8", name: "DL2 EU3" },
  { Modelo: "D9", Ver: "0.0.0", description: "Data  Log2  BT                DL2 ETI  D9", name: "DL2 ETI" }

]


export const DLNames = [
  {
    name: 'DL EU0', // Modelo 91
    languages: ['spanish', 'english', 'italian', 'portuguese', 'german']
  },
  {
    name: 'DL EU1', // Modelo 92
    languages: ['english', 'french', 'german', 'russian', 'slovak']
  },
  {
    name: 'DL EU2', // Modelo 93
    languages: ['norwegian', 'swedish', 'finnish', 'danish', 'english']
  },
  {
    name: 'DL AOM', // Modelo 94
    languages: ['english', 'french']
  },
  {
    name: 'DL ISR', // Modelo 95
    languages: ['english', 'french', 'german']
  },
  {
    name: 'DL OCL', // Modelo 96
    languages: ['english', 'french', 'spanish', 'portuguese', 'italian']
  },
  {
    name: 'DL EUE', // Modelo 97
    languages: ['polish', 'russian', 'slovenian', 'english', 'serbian']
  },
  {
    name: 'DL EU3', // Modelo 98
    languages: ['french', 'english', 'italian', 'portuguese', 'german']
  },
  {
    name: 'DL ETI', // Modelo 99
    languages: ['polish', 'slovenian', 'english', 'serbian']
  },
  {
    name: 'DL2 EU0', // Modelo D1
    languages: ['spanish', 'english', 'italian', 'portuguese', 'german']
  },
  {
    name: 'DL2 EU1', // Modelo D2
    languages: ['english', 'french', 'german', 'russian', 'slovak']
  },
  {
    name: 'DL2 EU2', // Modelo D3
    languages: ['norwegian', 'swedish', 'finnish', 'danish', 'english']
  },
  {
    name: 'DL2 AOM', // Modelo D4
    languages: ['english', 'french']
  },
  {
    name: 'DL2 ISR', // Modelo D5
    languages: ['english', 'french', 'german']
  },
  {
    name: 'DL2 OCL', // Modelo D6
    languages: ['english', 'french', 'spanish', 'portuguese', 'italian']
  },
  {
    name: 'DL2 EUE', // Modelo D7
    languages: ['polish', 'russian', 'slovenian', 'english', 'serbian']
  },
  {
    name: 'DL2 EU3', // Modelo D8
    languages: ['french', 'english', 'italian', 'portuguese', 'german']
  },
  {
    name: 'DL2 ETI', // Modelo D9
    languages: ['polish', 'slovenian', 'english', 'serbian']
  }
]
